export const SCRAPER_SOURCE_PLATFORMS = [
  { id: 'linkedin', label: 'LinkedIn (Sales Nav, Regular)' },
  { id: 'apollo', label: 'Apollo.io' },
  { id: 'crunchbase', label: 'Crunchbase' },
  { id: 'facebook', label: 'Facebook / Instagram' },
  { id: 'industry', label: 'Specific Industry Sites (e.g., Zillow, G2)' },
  { id: 'custom', label: 'Custom Website Scraping' },
  { id: 'other', label: 'Other' },
];

export const SCRAPER_SERVICE_TYPES = [
  { id: 'lead_generation', label: 'Lead Generation' },
  { id: 'company_data', label: 'Company Data Extraction' },
  { id: 'contact_finding', label: 'Contact Finding/Verification' },
  { id: 'market_research', label: 'Market Research Data' },
];
